import ReplayIcon from '@mui/icons-material/Replay';
import { AccordionProps, IconButton, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactElement } from 'react';
import { FormRichTextBubble } from 'src/components';
import { SiteDocumentationAccordion } from 'src/components/SidePanelTabs/SiteDocumentation/components/site-documentation-accordion';
import {
  ORG_NOTES_FIELD_NAME,
  ORG_NOTES_PLACEHOLDER,
} from 'src/components/SidePanelTabs/SiteDocumentation/site-documentation.constants';
import { DocumentationFormValue } from 'src/components/SidePanelTabs/SiteDocumentation/site-documentation.types';
import { SAVE_DEBOUNCE_DELAY } from 'src/constants/delays';

interface SiteOverviewSectionProps {
  expanded: boolean;
  onChange: AccordionProps['onChange'];
  orgNotesHasAISuggestion: boolean;
  isFormDisabled: boolean;
  onResetField: (fieldName: string) => void;
  onFieldChange: (fieldName: string, value: DocumentationFormValue) => void;
}

const richTextStyles = {
  border: 'none',
  '[data-placeholder]': {
    whiteSpace: 'pre-wrap',
  },
  '.portal-editor': {
    minHeight: '8rem',
  },
  '&:has(.ProseMirror:focus, .ProseMirror-focused)': {
    outline: 'none',
  },
};

export const SiteOverviewSection = ({
  expanded,
  onChange,
  orgNotesHasAISuggestion,
  isFormDisabled,
  onResetField,
  onFieldChange,
}: SiteOverviewSectionProps): ReactElement => {
  const theme = useTheme();

  return (
    <SiteDocumentationAccordion title="Site Overview" expanded={expanded} onChange={onChange}>
      <Stack spacing={2}>
        <Stack spacing={1}>
          {!!orgNotesHasAISuggestion && (
            <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.75rem',
                  padding: '0 4px',
                  borderRadius: '4px',
                  backgroundColor: theme.palette.custom.OV.sys.aiSuggestionsTextBackground,
                }}
              >
                AI appended text
              </Typography>

              <IconButton
                onClick={() => onResetField(ORG_NOTES_FIELD_NAME)}
                size="small"
                color="primary"
                title="Reset to original"
              >
                <ReplayIcon />
              </IconButton>
            </Stack>
          )}
          <FormRichTextBubble
            type="rich-text-bubble"
            name={ORG_NOTES_FIELD_NAME}
            watchContent
            disabled={isFormDisabled}
            placeholder={ORG_NOTES_PLACEHOLDER}
            debounced={SAVE_DEBOUNCE_DELAY}
            editorMaxHeight={null}
            onChange={(value: string) => onFieldChange(ORG_NOTES_FIELD_NAME, value)}
            richTextStyles={richTextStyles}
          />
        </Stack>
      </Stack>
    </SiteDocumentationAccordion>
  );
};
